const ROOT = `https://storage.googleapis.com/eleven-public-cdn/images/marketing`;

export const asset = `${ROOT}/projects-hero.png`;

export const config = [
  {
    name: `Seth Godin`,
    cover: `${ROOT}/akimbo.jpg`,
    author: `${ROOT}/seth-godin-avatar.png`,
  },
  {
    name: `HarperCollins`,
    cover: `${ROOT}/the-hobbit.jpg`,
    author: `${ROOT}/harpercollins-avatar.png`,
  },
  {
    name: `Perplexity`,
    cover: `${ROOT}/discover-daily.jpg`,
    author: `${ROOT}/perplexity-avatar.png`,
  },
  {
    name: `Storytel`,
    cover: `${ROOT}/dune.jpg`,
    author: `${ROOT}/storytel-avatar.png`,
  },
  {
    name: `ElevenLabs`,
    cover: `${ROOT}/sherlock-holmes.jpg`,
    author: `${ROOT}/elevenlabs-avatar.png`,
  },
];
